import React, { useState } from "react";
import { Sparkles, X } from "lucide-react";

const MOOD_STYLES = {
  urgent:          "bg-amber-50/70 dark:bg-amber-950/20 border-amber-100/70 dark:border-amber-800/30 text-amber-700 dark:text-amber-300",
  "pastoral-care": "bg-sky-50/70 dark:bg-sky-950/20 border-sky-100/70 dark:border-sky-800/30 text-sky-700 dark:text-sky-300",
  reflective:      "bg-violet-50/70 dark:bg-violet-950/20 border-violet-100/70 dark:border-violet-800/30 text-violet-700 dark:text-violet-300",
  neutral:         "bg-slate-50/80 dark:bg-slate-800/30 border-slate-200/50 dark:border-slate-700/30 text-slate-600 dark:text-slate-400",
};

/**
 * Passive, non-invasive insight card shown above suggestions.
 *
 * Design constraints:
 *  - Max 1 visible at a time (caller responsibility)
 *  - Dismissable
 *  - Calm — no pulsing, no badges, no urgency signals
 *  - Fades in softly using .animate-fade
 */
export const KeviaInsightCard = React.memo(function KeviaInsightCard({ insight, onDismiss }) {
  const [dismissed, setDismissed] = useState(false);

  if (!insight || dismissed) return null;

  const style = MOOD_STYLES[insight.mood] ?? MOOD_STYLES.neutral;

  const handleDismiss = () => {
    setDismissed(true);
    onDismiss?.();
  };

  return (
    <div
      className={`
        animate-fade flex items-start gap-2 px-3 py-2.5
        rounded-[14px] border ${style}
        transition-all duration-200 ease-out
      `}
      role="status"
      aria-label="Señal pastoral"
    >
      <Sparkles size={12} className="mt-[3px] shrink-0 opacity-60" />
      <span className="flex-1 text-[12px] leading-[1.5] font-medium opacity-85">
        {insight.explanation}
      </span>
      <button
        onClick={handleDismiss}
        className="shrink-0 rounded-full p-0.5 opacity-40 hover:opacity-70 transition-opacity active:scale-95"
        aria-label="Cerrar señal"
      >
        <X size={10} />
      </button>
    </div>
  );
});
